import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Which of the following is NOT an example of a resource you can rely upon if you or someone you know starts vaping and wants to stop?',
  inputType: 'radio',
  options: [
    {
      label: 'social media',
    },
    {
      label: 'text message programs',
    },
    {
      label: 'professional help',
    },
    {
      label: 'human resources',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[0].label,
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 4',
  path: '/challenge/question-4',
  content: (
    <Fragment>
      <Intro
        title="Question 4"
        direction="Select the item that best completes the statement."
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question4.js